import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
	return (
		<section className="section">
			<div className="container">
				<h2>Page not found</h2>
				<p className="helper">The page you are looking for doesn’t exist. You can return home below.</p>
				<Link className="btn" to="/">Back to Home</Link>
			</div>
		</section>
	);
}

export default NotFound;


